// import { IoMdCloudDone } from "react-icons/io";
// import { SiCyberdefenders } from "react-icons/si";
import { FaUserEdit } from "react-icons/fa";
import { FaVideo } from "react-icons/fa";
import { FaUserTie } from "react-icons/fa";
// import { FaUserEdit } from "react-icons/fa";
import project1 from  '../src/assets/project1.jpg'
import project2 from  '../src/assets/project2.jpg'
import project3 from  '../src/assets/project3.jpg'
import project4 from  '../src/assets/project4.jpg'

export const services = [
  {
    icon: FaVideo,
    title: {
      en: "Video Editor",
      ar: "مونتاج فيديو"
    },
    para: {
      en: "Professional video editing that tells your story.",
      ar: "تحرير فيديو احترافي يعبّر عن قصتك."
    }
  },
  {
    icon: FaUserEdit,
    title: {
      en: "Content Creator",
      ar: "صانع محتوى"
    },
    para: {
      en: "Creative content tailored to your brand.",
      ar: "محتوى إبداعي مناسب لهوية علامتك التجارية."
    }
  },
  {
    icon: FaUserTie,
    title: {
      en: "Digital Marketing",
      ar: "التسويق الرقمي"
    },
    para: {
      en: "Smart strategies to grow your business online.",
      ar: "استراتيجيات ذكية لتنمية عملك أونلاين."
    }
  }
];


// export const projects = [
//   {
//     img: project1,
//     title: 'Digital Marketing Team',
//     para: 'Our Family who analyzes, creates, designs, and manages your digital marketing campaigns.'
//   },
//   {
//     img: project2,
//     title: 'Content Creation Team',
//     para: 'Responsible for delivering your creative content in a way that strengthens your brand.'
//   },
//   {
//     img: project3,
//     title: 'Social Media Management',
//     para: 'Work on the strategy of scheduling, publishing, engaging with audiences, and analyzing content across social platforms to build brand awareness.'
//   },
//   {
//     img: project4,
//     title: 'Analytics & Strategy Team',
//     para: 'Analyzing large amounts of information to develop business strategies that drive your brand forward.'
//   },
// ];
export const projects = [
  {
    img: project1,
    title: {
      en: "Digital Marketing Team",
      ar: "فريق التسويق الرقمي"
    },
    para: {
      en: "Our family who analyzes, creates, designs, and manages your digital marketing campaigns.",
      ar: "فريقنا المتخصص في تحليل وتصميم وإدارة حملاتك التسويقية الرقمية."
    }
  },
  {
    img: project2,
    title: {
      en: "Content Creation Team",
      ar: "فريق صناعة المحتوى"
    },
    para: {
      en: "Responsible for delivering your creative content in a way that strengthens your brand.",
      ar: "مسؤول عن تقديم محتوى إبداعي يعزز قوة علامتك التجارية."
    }
  },
  {
    img: project3,
    title: {
      en: "Social Media Management",
      ar: "إدارة وسائل التواصل الاجتماعي"
    },
    para: {
      en: "Scheduling, publishing, engaging with audiences, and analyzing content across social platforms.",
      ar: "تنظيم ونشر المحتوى والتفاعل مع الجمهور وتحليل الأداء على منصات التواصل."
    }
  },
  {
    img: project4,
    title: {
      en: "Analytics & Strategy Team",
      ar: "فريق التحليل والاستراتيجية"
    },
    para: {
      en: "Analyzing data to build smart strategies that drive your brand forward.",
      ar: "تحليل البيانات وبناء استراتيجيات ذكية تدفع علامتك التجارية للأمام."
    }
  }
];


export const reviews = [
  {
    rating: "4.8",
    about: {
      en: "A game-changer for Shelter Restaurant. Their creative strategies significantly boosted our visibility and customer traffic. Highly professional team and results-driven!",
      ar: "نقلة حقيقية لمطعم شيلتر. استراتيجياتهم الإبداعية زودت ظهورنا وعدد العملاء بشكل ملحوظ. فريق محترف ويركز على النتائج."
    },
    name: {
      en: "Mr. Ehab ELmekawy",
      ar: "أ/ إيهاب المكّاوي"
    },
    role: {
      en: "Shelter Restaurant",
      ar: "مطعم شيلتر"
    }
  },
  {
    rating: "3.5",
    about: {
      en: "They positioned Hamed Abdallah Optical perfectly in the market. Creative campaigns with exceptional results.",
      ar: "قدروا يثبتوا مكانة حامد عبدالله للبصريات في السوق بشكل مثالي، بحملات إبداعية ونتائج مميزة."
    },
    name: {
      en: "Mr. Ahmed Hamed Abdallah",
      ar: "أ/ أحمد حامد عبدالله"
    },
    role: {
      en: "Hamed Abdallah Optical",
      ar: "حامد عبدالله للبصريات"
    }
  },
  {
    rating: "4.2",
    about: {
      en: "The team took Fattouma Restaurant to a whole new level. Their marketing expertise increased our reach and orders.",
      ar: "الفريق نقل مطعم فاطومة لمستوى مختلف تمامًا، وزاد الانتشار والطلبات بشكل واضح."
    },
    name: {
      en: "Mr. Karim Abou El-Magd",
      ar: "أ/ كريم أبو المجد"
    },
    role: {
      en: "Fattouma Restaurant",
      ar: "مطعم فاطومة"
    }
  },
  {
    rating: "3.9",
    about: {
      en: "An incredible partnership. Their marketing strategies gave Daqdooka Restaurant a massive boost.",
      ar: "شراكة رائعة، واستراتيجياتهم التسويقية عملت دفعة قوية لمطعم دقدوقة في السوق."
    },
    name: {
      en: "Mr. Saeed Daqdooka",
      ar: "أ/ سعيد دقدوقة"
    },
    role: {
      en: "Daqdooka Restaurant",
      ar: "مطعم دقدوقة"
    }
  },
  {
    rating: "4.7",
    about: {
      en: "Our brand K&L achieved remarkable growth thanks to their innovative marketing approach.",
      ar: "علامتنا التجارية K&L حققت نمو ملحوظ بفضل أسلوبهم التسويقي المبتكر."
    },
    name: {
      en: "Mr. Mohamed Kerat",
      ar: "أ/ محمد قيراط"
    },
    role: {
      en: "K&L",
      ar: "K&L"
    }
  },
  {
    rating: "4.8",
    about: {
      en: "Working with this agency was the best investment for Teta Restaurant.",
      ar: "العمل مع الوكالة دي كان أفضل استثمار لمطعم تيتا."
    },
    name: {
      en: "Mr. Mahmoud El Mosally",
      ar: "أ/ محمود المصلي"
    },
    role: {
      en: "Teta Restaurant",
      ar: "مطعم تيتا"
    }
  },
  {
    rating: "4.8",
    about: {
      en: "They helped me build a professional digital presence that reflects my medical expertise.",
      ar: "ساعدوني أبني حضور رقمي احترافي يعكس خبرتي الطبية ويزيد ثقة المرضى."
    },
    name: {
      en: "Dr. Karim Ayman",
      ar: "د/ كريم أيمن"
    },
    role: {
      en: "Medical Doctor",
      ar: "طبيب"
    }
  }
];